import CommandStack from './CommandStack';

export default {
  commandStack: [ 'type', CommandStack ]
};
